import { useAtom } from 'jotai';
import * as state from '../state';
import { SUPPORT_ERROR_MESSAGE } from '@/constants';
import Button from '@mui/material/Button';
import { GenericConfirmationDialog } from '@/components/Analysis/shared/GeneriConfirmationDialog';

export const ServiceGroupUploadErrorDialog = () => {
  const [serviceGroupUploadState, setServiceGroupUploadState] = useAtom(
    state.serviceGroupUploadState
  );

  const onClose = () => {
    setServiceGroupUploadState((previous) => ({
      ...previous,
      error: undefined,
      inputCsv: undefined,
      state: 'idle',
    }));
  };

  return (
    <GenericConfirmationDialog
      open={serviceGroupUploadState.state === 'generic-error'}
      onClose={onClose}
      title="Validation Error"
      description={
        typeof serviceGroupUploadState.error?.message === 'string'
          ? serviceGroupUploadState.error?.message
          : SUPPORT_ERROR_MESSAGE
      }
      body={<></>}
    >
      <Button variant="contained" onClick={onClose}>
        Got it
      </Button>
    </GenericConfirmationDialog>
  );
};
